import {type ReactNode} from 'react'
import * as Sentry from '@sentry/react'
import {reportError} from '../../../common/errors/reportError'
import SorryPage from '../../pages/SorryPage'

interface AppErrorBoundaryProps {
  children: ReactNode
}

const renderFallback = ({error}: {error: unknown}) => {
  const err = error instanceof Error ? error : new Error(String(error))
  return <SorryPage variant="fatal" error={err} />
}

const handleError = (error: unknown, componentStack: string) => {
  reportError(error, 'AppErrorBoundary', {componentStack})
}

const AppErrorBoundary = ({children}: AppErrorBoundaryProps) => (
  <Sentry.ErrorBoundary fallback={renderFallback} onError={handleError}>
    {children}
  </Sentry.ErrorBoundary>
)

export default AppErrorBoundary
